import { get } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import withLanguages from '../withLanguages.graphql';
import useT from '../../components/utils/Translations/useT';
export default function useLanguages() {
    const t = useT();
    const { data, error, loading } = useQuery(withLanguages, {
        fetchPolicy: 'cache-first',
    });
    const languages = useMemo(() => get(data, 'languages', []), [data]);
    return {
        languages: languages.map(r => ({
            ...r,
            name: t(r.name),
            value: r.name,
        })),
        error,
        loading,
    };
}
